/** @format */

import axios from "axios";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";

import So from "./cards/So";
import Manbalar from "./cards/Manbalar";
import Balanslar from "./cards/Balanslar";
import Chart3 from "../../components/Chart3";
import Chart6 from "../../components/Chart6";
import Chart10 from "../../components/Chart10";
import Chart11 from "../../components/Chart11";
import SugorishCart from "./cards/SugorishCart";
import { header } from "../../../../components/api/Header";
import ErrorBoundary from "../../../../components/ErrorBoundry";
import { getEnv } from "../../../../lib/env";

function Sirdaryo({ date }) {
  const [data, setData] = useState({});
  const districts = useSelector((state) => state.data.districts);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${getEnv('REACT_APP_BASE_URL')}/v1/republik/dashboard/charts?date=${date}`,
          header()
        );
        setData(res.data || {});
      } catch (e) {
        console.error("Error fetching dashboard data", e);
      }
    };
    fetchData();
  }, [date]);

  return (
    <div className='dashboard'>
      <div className='mgk-box and'>
        <Balanslar date={date} a={0} s={1} z={0} />
        <So date={date} />
        <SugorishCart />
      </div>

      <div className='data-content card3 mt-3'>
        <div className='card statistic-card bosh-sahifa-barchart px-2'>
          <ErrorBoundary>
            <Chart11 districts={districts} />
          </ErrorBoundary>
        </div>

        <div className='card statistic-card bosh-sahifa-barchart px-2'>
          <ErrorBoundary>
            <Chart10 districts={districts} />
          </ErrorBoundary>
        </div>
      </div>

      <Manbalar date={date} singlerow={0} region='and' />

      <div className='jizz'>
        <div className='row'>
          <div className='col-md-6'>
            <Chart3 data={data?.o} />
          </div>

          <div className='col-md-6'>
            <Chart6 data={data?.q} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sirdaryo;
